import { gql } from "@apollo/client";

export const VALIDATE_FUNDING_REQUESTS = gql`
  mutation ValidateFundingRequests(
    $request: BrokerFundingRequestInput
    $contractType: String!
    $status: String!
  ) {
    validateFundingRequests(request: $request, contractType: $contractType, status: $status) {
      results {
        id
        valid
        errors
        warnings
      }
    }
  }
`;

export const QUERY_BROKER_FUNDING_REQUEST = gql`
  query FundingRequest($id: ID) {
    fundingRequest(id: $id) {
      additionalDiscountRate
      created
      modified
      id
      warnings
      metadata
      amount
      unpaidPurchaseAmount
      billToAddress
      billToCompanyEmail
      billToCompanyPhone
      firstOriginLocation
      finalDestinationLocation
      loadLength
      loadTrailerType
      fundedAt
      brokerFundedAt
      scheduledPurchaseDate
      userReferenceNumber
      userNotes
      invoiceNumber
      discountRate
      displayDiscountRate
      fuelAdvanceRate
      fuelAdvanceFee
      fuelAdvanceAmount
      invoiceNotes
      carrierInvoiceNotes
      debtorInvoiceNotes
      invoiceSent
      invoiceSentCount
      lastInvoiceSentTime
      selfFinanceRequested
      contractType
      contractVersion
      source
      status
      statusNote
      userLoadNumber
      purchaseOrderNumber
      factored
      nonFactoredType
      chargeNonFactoredFee
      MinimumFee
      paymentMethod
      fuelAdvancePaymentMethod
      amountFunded
      attachments {
        id
        filename
        downloadUrl
        category
        visibleTo
        uploaded
      }
      paymentStatus
      paymentProfileAmount
      paymentProfilePaymentMethod
      paymentProfileDiscountRate
      paymentProfileFundedAt
      paymentProfileFundedAmount
      factoringAmountOffset
      factoringAmount
      factoringFeeSplitRate
      fuelAdvanceFeeSplitRate
      reserveHoldbackRate
      carrierProNumber
      reserveHoldback
      selectedFeeSplit
      passDebtorRateToCarrier
      applyReserveHoldback
      payoutDays
      invoiceDate
      carrierEditLocked
      receivableStatus
      receivablePaidDate
      receivablePaidAmount
      canBrokerDecline
      canCancelCarrierPayment
      canResendRateConfirmation
      carrierFundingCommitted
      frType
      clientInvoiceNumber
      factoring {
        id
        companyProfile
        ownerProfile
        factoringApproved
        discountRate
        marginDiscountRate
        attachments
        noaAttachments
        MinimumFee
        brokerApproved
        fuelAdvance
        fuelAdvanceRate
        fuelAdvanceFee
        fuelAdvanceLimit
        enableDiscount
        showDebtorDeclined
        createNonFactoredFr
        reserveHoldback
        reserveHoldbackRate
        nonFactoredFee
        allowNegativeMargin
        negativeMarginValue
        negativeMarginLimit
        enableReserveHoldbackHybrid
        defaultEnableReserveHoldback
        sendRateConfirmationRemoteApproved
        allowSelfFinanceFr
        stripeEnabled
        selfFinanceFrLimit
        selfFinanceRolling30DayFrLimit
        selfFinanceApprovalWithoutNoa
        companySettings
        enabledContractTypes
        ccBrokerRateConfirmationEmail
      }
      debtor {
        coBrokerAllowed
        created
        modified
        id
        email
        noaContactEmail
        paymentStatusEmail
        name
        companyName
        address
        phoneNumber
        faxNumber
        mc
        dot
        taxId
        avgpay
        creditApproved
        creditApprovedNote
        creditLimit
        creditAvailable
        originalsRequired
        dtpAllowance
        discountRate
        dunsNumber
        profileVerified
      }
      paymentProfile {
        id
        created
        modified
        status
        authority
        companyName
        companyPhoneNumber
        ownerEmail
        companyMc
        companyDot
        paymentMethod {
          method
          accountNumberRedacted
        }
        brokerPaymentProfileRelation {
          coBrokeringApproval
          payoutDays
          factoringFeeSplitRate
          factoringCompanyRelation {
            id
            factoringCompany {
              id
              name
              account {
                accountNumberRedacted
                method
              }
            }
          }
        }
        fmcsaEmail
        remittanceEmail
      }
      factoringCompany {
        id
        created
        modified
        name
        email
        contactName
        contactEmail
        streetOne
        streetTwo
        city
        state
        zipCode
        phoneNumber
        status
        uploaded
        deleted
        account {
          method
          accountNumberRedacted
        }
      }
      load {
        id
      }
      factoringDebtorRelation {
        id
        noaSent
        noaPlaced
        noaActive
        noaRequested
        creditApproved
      }
      brokerMarginStatus
      carrierPaymentStatus
      frLineItems {
        id
        created
        category
        description
        amount
      }
      paymentProfileAccount {
        id
        accountNumberRedacted
        method
      }
      purchases {
        category
        amount
        postingDate
      }
    }
  }
`;

export const QUERY_CARRIER_FUNDING_REQUEST = gql`
  query FundingRequest($id: ID, $assignedLoad: Boolean) {
    fundingRequest(id: $id, assignedLoad: $assignedLoad) {
      created
      modified
      id
      amount
      displayAmount
      unpaidPurchaseAmount
      billToAddress
      billToCompanyEmail
      billToCompanyPhone
      firstOriginLocation
      finalDestinationLocation
      loadLength
      loadTrailerType
      fundedAt
      userReferenceNumber
      userNotes
      invoiceNumber
      discountRate
      displayDiscountRate
      fuelAdvanceRate
      fuelAdvanceFee
      fuelAdvanceAmount
      invoiceSent
      invoiceSentCount
      lastInvoiceSentTime
      selfFinanceRequested
      contractType
      source
      status
      statusNote
      userLoadNumber
      purchaseOrderNumber
      factored
      nonFactoredType
      MinimumFee
      paymentMethod
      fuelAdvancePaymentMethod
      amountFunded
      attachments {
        id
        filename
        downloadUrl
        category
        visibleTo
        uploaded
      }
      debtor {
        created
        modified
        id
        email
        noaContactEmail
        paymentStatusEmail
        name
        companyName
        address
        phoneNumber
        faxNumber
        mc
        dot
        taxId
        avgpay
        creditApproved
        creditApprovedNote
        creditLimit
        originalsRequired
        dtpAllowance
        discountRate
        dunsNumber
        creditAvailable
      }
      paymentStatus
      paymentProfilePaymentMethod
      paymentProfileDiscountRate
      paymentProfileFundedAt
      factoringAmount
      factoringFeeSplitRate
      fuelAdvanceFeeSplitRate
      reserveHoldbackRate
      carrierProNumber
      reserveHoldback
      selectedFeeSplit
      applyReserveHoldback
      paymentProfileAmount
      paymentProfileFundedAmount
      payoutDays
      invoiceDate
      frType
      clientInvoiceNumber
      paymentProfile {
        companyName
        id
      }
      factoringDebtorRelation {
        id
        noaSent
        noaPlaced
        noaActive
        noaRequested
        creditApproved
      }
      amountFunded
      debtorAdvance
      factoring {
        id
        companyProfile
        ownerProfile
        factoringApproved
        discountRate
        marginDiscountRate
        attachments
        noaAttachments
        MinimumFee
        brokerApproved
        fuelAdvance
        fuelAdvanceRate
        fuelAdvanceFee
        fuelAdvanceLimit
        enableDiscount
        showDebtorDeclined
        createNonFactoredFr
        reserveHoldback
        reserveHoldbackRate
        nonFactoredFee
        allowNegativeMargin
        negativeMarginValue
        negativeMarginLimit
        enableReserveHoldbackHybrid
        defaultEnableReserveHoldback
        sendRateConfirmationRemoteApproved
        allowSelfFinanceFr
        stripeEnabled
        selfFinanceFrLimit
        selfFinanceRolling30DayFrLimit
        selfFinanceApprovalWithoutNoa
        companySettings
        enabledContractTypes
        ccBrokerRateConfirmationEmail
      }
      metadata
      autoInvoice
    }
  }
`;
